module.exports = __webpack_public_path__ + "media/images/icon-without-avatar-f63af2e59e6604986f43cfc0480066b8.png";